// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__7mLMO","triangle":"popup_triangle__iPsIO","middle":"popup_middle__MtExY","right":"popup_right__koNEm","extremeLeft":"popup_extremeLeft__metQp"};